import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import type { BillingFeature } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import ToolTipComponent from 'webapp/components/tool-tip';

import type { TrackingOriginTypeForTrialPopupOpened } from 'webapp/services/billing';

interface Args {
	feature?: BillingFeature;
	trackingOrigin?: string;
	text?: string;
}

export default class BillingLimitationWarningComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;

	get text() {
		let text = this.args.text || 'Feature not available.';
		if (this.args.feature) {
			text += ' Click for more details.';
		}
		return text;
	}

	@action
	handleLimitations() {
		if (this.args.feature) {
			this.billingService.handleLimitations(
				this.args.feature,
				this.args.trackingOrigin as TrackingOriginTypeForTrialPopupOpened,
			);
		}
	}
	<template>
		<div
			role="button"
			class="limitation-warning {{if @feature 'clickable'}}"
			{{on "click" this.handleLimitations}}
		>
			<CommonUiIconComponent @name="Lock" @size="sm" @class="icon limitation-warning-icon" />
			<ToolTipComponent @text={{this.text}} />
		</div>
	</template>
}
